module.exports = __webpack_public_path__ + "static/media/microchip.e0a75092.svg";